document.addEventListener("DOMContentLoaded", function () {
  const btns = document.querySelectorAll(".show-more-btn");

  btns.forEach((btn) => {
    const text = btn.previousElementSibling; 

    btn.addEventListener("click", function () {
      text.classList.toggle("expanded");

      if (text.classList.contains("expanded")) {
        btn.textContent = "Show less";
      } else {
        btn.textContent = "Read more";

        
        window.scrollTo({
          top: 400,
          behavior: "smooth",
        });
      }
    });
  });
});
